import { Component, Input } from "@angular/core";

@Component({
	selector: "app-status-tile",
	templateUrl: "./status-tile.component.html",
	styleUrls: ["./status-tile.component.scss"],
})
export class StatusTileComponent {
	@Input()
	location: string;

	@Input()
	timeAgo: string;
}
